import { render, staticRenderFns } from "./OlabCartProfile.vue?vue&type=template&id=725dcc25&"
import script from "./OlabCartProfile.vue?vue&type=script&lang=js&"
export * from "./OlabCartProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports